module.exports = __webpack_public_path__ + "static/media/proposito.9e78181b.jpg";